/**
 * Prescriptions (NEW-WF-12, MM-14; its own module since owner feedback
 * 2026-10-21): `/rx` in the Clinical sidebar group lists the office's
 * prescriptions (filters, drafts to sign, reprint, void) or one patient's
 * history (`?patient=`). Write Rx is a drawer opened from the patient
 * header, the chart, this page and Ctrl+K "Write prescription"
 * (global/WriteRxHost.tsx). Printing files the PDF to Documents and the
 * clinical note. eRx (DoseSpot) is not set up (INF-04) and says "coming".
 */
import { defineManifest } from '@velora/contracts';
import { RX_PERMISSIONS as P } from '@velora/contracts/rx';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'rx',
    title: 'Prescriptions',
    version: '0.2.0',
    owner: 'WP4-RX',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'rx',
        path: '/rx',
        title: 'Prescriptions',
        officeScope: 'location-or-all',
        permission: P.view,
        readsPhi: true,
      },
      {
        id: 'setup',
        path: '/settings/prescriptions',
        title: 'Prescription templates and prescribers',
        officeScope: 'location-or-all',
        permission: P.manage,
      },
    ],
    nav: [
      {
        label: 'Prescriptions',
        group: 'clinical',
        routeId: 'rx',
        icon: 'pill',
        order: 60,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'rx.open',
        title: 'Prescriptions',
        keywords: ['rx', 'prescription', 'prescriptions list', 'reprint', 'drafts to sign', 'erx'],
        routeId: 'rx',
        permission: P.view,
      },
      {
        id: 'rx.setup',
        title: 'Prescription templates and prescriber DEA',
        keywords: ['rx templates', 'dea', 'prescriber', 'license', 'prescription setup'],
        routeId: 'setup',
        permission: P.manage,
      },
    ],
    sseEntityKeys: ['prescription'],
    phiReadPoints: ['rx.list', 'rx.office_list', 'rx.history'],
  }),
  pages: {
    rx: () => import('./RxPage.js'),
    setup: () => import('./RxSetupPage.js'),
  },
});
